import moment from 'moment'

/**
 * Merges start and end time filter values (date arrays) into a two-element array of moments
 * @param startValue - The start time filter value (array with [startDate, endDate])
 * @param endValue - The end time filter value (array with [startDate, endDate])
 * @returns A two-element array of moment objects [startMoment, endMoment]
 */
export function mergeInterval(
  startValue: string[] | undefined,
  endValue: string[] | undefined
): string[] {
  if (!startValue && !endValue) {
    return []
  }

  if (!startValue && endValue && endValue.length >= 2) {
    return [endValue[0], endValue[1]]
  }

  if (startValue && startValue.length >= 2 && !endValue) {
    return [startValue[0], startValue[1]]
  }

  if (
    startValue &&
    startValue.length >= 2 &&
    endValue &&
    endValue.length >= 2
  ) {
    const earliestStart = moment.min(moment(startValue[0]), moment(endValue[0]))
    const latestEnd = moment.max(moment(startValue[1]), moment(endValue[1]))

    return [
      earliestStart.format('YYYY-MM-DD HH:mm:ss'),
      latestEnd.format('YYYY-MM-DD HH:mm:ss'),
    ]
  }

  return []
}
